/**
 * Main entrypoint for Namefully
 */
export * from './Namefully'
export { default as Namefully } from './Namefully'
